var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/turnovertype-new.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-294b470f!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/turnovertype-new.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/TurnoverTypeNew.vue
// module id = 725
// module chunks = 1